export const usePowerUpStore = defineStore('powerUpStore', {
  state: () => ({
    speedLevel: 0,
    powerLevel: 0,
    shuttleLevel: 0,
    fragment: 100,
    isLoadedGame: false,
    powerUpContainerPosition: {
      top: 0,
      left: 0,
    },
    dontShowReminder: false,
    powerUp: '',
    powerUps: [],
    upgrades: [],
    isDisableNextButton: false,
    isDisablePrevButton: false,
  }),

  actions: {
    async getUpgrades() {
      const api = useApi()
      const upgrades = await api.getUpgrades()
      this.upgrades = upgrades
    },
    async getPowerUps() {
      const api = useApi()
      const powerUps = await api.getPowerUps()
      this.powerUps = powerUps
    },
    async getGameData() {
      const api = useApi()
      const userUpgrades = await api.userUpgrades()
      const gameData = userUpgrades.reduce((key, item) => {
        key[`${item.upgrade}Level`] = item.currentLevel
        return key
      }, {})
      this.shuttleLevel = gameData.shuttleLevel - 1
      this.speedLevel = gameData.speedLevel - 1
      this.powerLevel = gameData.powerLevel - 1
    },

    async incrementSpeed() {
      this.isDisablePrevButton = false
      if (this.speedLevel === 8) this.isDisableNextButton = true
      if (this.speedLevel > 8) {
        return
      } else {
        this.speedLevel++
      }
    },

    async decrementSpeed() {
      this.isDisableNextButton = false
      if (this.speedLevel <= 1) this.isDisablePrevButton = true
      if (this.speedLevel === 0) {
        return
      } else {
        this.speedLevel--
      }
    },

    async incrementPower() {
      this.isDisablePrevButton = false
      if (this.powerLevel === 18) this.isDisableNextButton = true
      if (this.powerLevel > 18) {
        return
      } else {
        this.powerLevel++
      }
    },

    async decrementPower() {
      this.isDisableNextButton = false
      if (this.powerLevel <= 1) this.isDisablePrevButton = true
      if (this.powerLevel === 0) {
        return
      } else {
        this.powerLevel--
      }
    },

    async incrementShuttleLevel() {
      this.isDisablePrevButton = false
      if (this.shuttleLevel === 3) this.isDisableNextButton = true
      if (this.shuttleLevel > 3) {
        return
      } else {
        this.shuttleLevel++
      }
    },

    async decrementShuttleLevel() {
      this.isDisableNextButton = false
      if (this.shuttleLevel <= 1) this.isDisablePrevButton = true
      if (this.shuttleLevel === 0) {
        this.isDisablePrevButton = true
        return
      } else {
        this.shuttleLevel--
      }
    },

    async setDontShow(value) {
      this.dontShowReminder = value
    },
  },
})
